import React, { Component } from 'react';
import cx from 'classnames';

import styles from './TextInput.css';

function Link(props) {
	const { className, text, callback, success, disabled } = props;
	const classNames = cx(styles['form-input-link'], className, {
		[styles['disabled']]: disabled,
		[styles['success']]: success
	});
	return (
		<a className={classNames} onClick={!disabled && !success && callback.bind(this)}>
			{text}
		</a>
	);
}

export default class TextInput extends Component {
	constructor(args) {
		super(args);
		this.state = {
			text: args.value || ''
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({ text: nextProps.value || '' });
	}

	componentDidMount() {
		const { captureAutoFill } = this.props;
		/* >> Workaround to detect autofill and update the state value with the latest value
		 *  As in browser (except in chrome) there is no css pseudo-class to detect form autofill also we can't detect
		 *  it using DOM event as browser doesn't emit any event after autofilling form fields because of security reason.
		 *  Its already a known issue and there are several workaround available.
		 *  You can see the chrome autofill bug here : https://bugs.chromium.org/p/chromium/issues/detail?id=352527 */
		if (captureAutoFill) {
			this.timeout = setTimeout(() => {
				const value = this.input.value;
				if (value !== '' && this.state.text !== value) {
					// Explicitly triggering onChange method to update the state value
					this.onChange({ target: this.input });
				}
			}, 300);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.autoFocus !== this.props.autoFocus && this.props.autoFocus === true) {
			this.input && this.input.focus();
		}
	}

	componentWillUnmount() {
		// Clears the timeout in case component unmount within 300ms
		clearTimeout(this.timeout);
	}

	onChange = e => {
		const { onTextChange, pattern } = this.props;
		let value = e.target.value;
		if (value !== '' && pattern && typeof pattern.test === 'function' && !pattern.test(value)) {
			e && e.preventDefault();
			return;
		}
		if (typeof onTextChange === 'function') {
			const returnValue = onTextChange(value, this.props.id);
			value = typeof returnValue !== 'undefined' ? returnValue : value;
		}
		this.setState({
			text: value
		});
	};

	handleOnFocus = () => {
		if (typeof this.props.onFocus === 'function') {
			this.props.onFocus();
		}
	};

	handleKeyDown = e => {
		if (typeof this.props.onKeyDown === 'function') {
			this.props.onKeyDown(e);
		}
	};

	handleKeyUp = e => {
		if (typeof this.props.onKeyUp === 'function') {
			this.props.onKeyUp(e);
		}
	};

	setInputRef = c => (this.input = c);

	render() {
		const {
			prependInfo,
			appendInfo,
			className,
			placeholder,
			children,
			autoComplete,
			type,
			autoFocus,
			maxLength,
			readOnly,
			linkConfig,
			errorMsg,
			disabled,
			wrapperClass,
			placeholderClass,
			required
		} = this.props;
		const { text } = this.state;
		return (
			<div className={cx(styles['form-input-wrap'], wrapperClass)}>
				<input
					ref={this.setInputRef}
					readOnly={readOnly || false}
					maxLength={maxLength}
					autoComplete={autoComplete || 'off'}
					type={type || 'text'}
					autoFocus={autoFocus || false}
					className={cx(
						styles['form-input'],
						{ [styles['valid']]: text },
						{ [styles['form-input-prepend-info']]: prependInfo },
						{ [styles['form-input-append-info']]: appendInfo },
						{ [styles['form-input-error']]: errorMsg },
						className
					)}
					value={text}
					onFocus={this.handleOnFocus}
					onKeyDown={this.handleKeyDown}
					onKeyUp={this.handleKeyUp}
					onChange={this.onChange}
					required={required}
					disabled={disabled || false}
				/>
				<span className={cx(styles['form-input-bar'], { [styles['valid']]: Boolean(text) })} />
				<label className={cx(placeholderClass, styles['placeholder-txt'], { [styles['valid']]: Boolean(text) })}>
					{placeholder}
				</label>
				{linkConfig && <Link {...linkConfig} />}
				{children}
				{errorMsg ? <span className={styles['form-error-txt']}>{errorMsg}</span> : null}
			</div>
		);
	}
}
